import type { LibraryExam } from "../../../../packages/published-content/library";

export type TestCatalogStatus = "full" | "partial";

export function testCatalogStatus(exam: LibraryExam): TestCatalogStatus {
  return ["fixed_ready", "adaptive_ready"].includes(exam.eligibility) && exam.available === 98 && exam.expected === 98
    ? "full"
    : "partial";
}

export function testCatalogStatusLabel(exam: LibraryExam) {
  return testCatalogStatus(exam) === "full"
    ? exam.eligibility === "adaptive_ready" ? "Adaptive full exam · 98/98" : "Full exam · 98/98"
    : `Partial exam · ${exam.available}/${exam.expected}`;
}

export function testSectionAvailability(exam: LibraryExam, section: "rw" | "math") {
  const available = section === "rw" ? exam.availableReadingWriting : exam.availableMath;
  const expected = section === "rw" ? exam.expectedReadingWriting : exam.expectedMath;
  if (typeof available === "number" && typeof expected === "number") return { available, expected };
  if (testCatalogStatus(exam) === "full") return section === "rw" ? { available: 54, expected: 54 } : { available: 44, expected: 44 };
  return null;
}
